import React from 'react';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import { MediaSourceType } from '../../../types';
import ArrowDownIcon from '@wix/da-ds/pkg/Icons/ArrowDown';
import withCurrentMediaSource, {
  WithCurrentMediaSourceProps,
} from '../../../_hocs/withCurrentMediaSource';

import {
  getTransKeyForMediaSourceType,
  getAllMediaSourceTypes,
} from '../_helpers';
import mediaSourceMenuMobileStyles from './MediaSourceMenuMobile.scss';

export interface Props {
  mediaSourceTypes?: MediaSourceType[];
}

const enhance = compose(withCurrentMediaSource);
export const MediaSourceMenu: React.FC<Props & WithCurrentMediaSourceProps> = ({
  currentMediaSource,
  mediaSourceTypes,
  changeCurrentMediaSource,
}) => {
  const { t } = useTranslation();
  return (
    <div className={mediaSourceMenuMobileStyles['root']}>
      {t!(getTransKeyForMediaSourceType(currentMediaSource))}
      <ArrowDownIcon className={mediaSourceMenuMobileStyles['icon']} />
      <select
        value={currentMediaSource}
        onChange={event =>
          changeCurrentMediaSource(event.target.value as MediaSourceType)
        }
      >
        {(mediaSourceTypes || getAllMediaSourceTypes()).map(
          (mediaSourceType, key) => {
            return (
              <option key={key} value={mediaSourceType}>
                {t!(getTransKeyForMediaSourceType(mediaSourceType))}
              </option>
            );
          }
        )}
      </select>
    </div>
  );
};
MediaSourceMenu.displayName = 'MediaSourceMenu';

export default enhance(MediaSourceMenu) as React.ComponentClass<Props>;
